import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {BaseHttpService} from '@shared/infrastructure/services/http/base-http.service';
import {environment} from '@env/environment';
import {CheckoutPayload} from '@features/payment/infrastructure/dto/payment-payload.dto';
import {PaymentCheckoutError} from '@features/payment/domain/model/payment.errors';

interface CheckoutResponse {
  batchPaymentId: string;
}

@Injectable({providedIn: 'root'})
export class CheckoutGateway extends BaseHttpService {
  protected readonly baseUrl = environment.apiURL;

  checkoutOnline(payload: CheckoutPayload, options?: {headers?: Record<string, string>, params?: Record<string, unknown>}): Observable<string> {
    return this.post<CheckoutResponse>('/api/v2/accounts/checkout-online', payload, options).pipe(
      map(({batchPaymentId}) => batchPaymentId),
      catchError(() => throwError(() => new PaymentCheckoutError()))
    );
  }
}
